module.exports = __webpack_public_path__ + "img/undraw_qr.a965e06f.png";